<div class="reminders-view">
    <!-- Header Section -->
    <div class="view-header">
        <div class="header-content">
            <h2>Automated Follow-up Rules</h2>
            <p>Configure dynamic reminders triggered after an assessment invitation is sent.</p>
        </div>
        <!-- Global Save Removed -->
    </div>

    <div class="reminders-grid">
        <!-- Left Column: Rules Config -->
        <div class="rules-column">

            <div class="reminder-card" *ngFor="let reminder of reminders; let i = index" [id]="'reminder-card-' + i"
                [class.disabled-state]="!reminder.isEnabled">
                <div class="card-header">
                    <div class="header-left">
                        <div class="step-badge">#{{i + 1}}</div>
                        <input type="text" [(ngModel)]="reminder.name" (ngModelChange)="markModified(reminder)"
                            class="reminder-name-input" placeholder="Reminder Name">
                    </div>

                    <div class="header-right">

                        <!-- Enable Switch -->
                        <div class="status-toggle"
                            (click)="reminder.isEnabled = !reminder.isEnabled; markModified(reminder)"
                            [class.active]="reminder.isEnabled"
                            [matTooltip]="reminder.isEnabled ? 'Rule Enabled' : 'Rule Disabled'">
                            <span class="label">{{reminder.isEnabled ? 'ON' : 'OFF'}}</span>
                            <div class="switch-track">
                                <div class="knob"></div>
                            </div>
                        </div>

                        <button mat-icon-button class="delete-btn" (click)="removeReminder(i)"
                            *ngIf="reminders.length > 0" matTooltip="Remove Reminder">
                            <mat-icon>close</mat-icon>
                        </button>
                    </div>
                </div>

                <div class="card-body-content" [class.faded]="!reminder.isEnabled">
                    <div class="card-controls-row">
                        <!-- Schedule Config (Updated Layout) -->
                        <div class="control-group schedule-group">
                            <label>Schedule Timing</label>
                            <div class="schedule-box">
                                <!-- After Row -->
                                <div class="schedule-row">
                                    <span class="row-label">After</span>
                                    <div class="input-set">
                                        <input type="number" [(ngModel)]="reminder.delayValue"
                                            (ngModelChange)="markModified(reminder)" min="1"
                                            [max]="reminder.delayUnit === 'Days' ? 20 : null" class="delay-val">
                                        <div class="select-wrapper unit-select">
                                            <select [(ngModel)]="reminder.delayUnit"
                                                (ngModelChange)="markModified(reminder)">
                                                <option value="Minutes">Minutes</option>
                                                <option value="Hours">Hours</option>
                                                <option value="Days">Days</option>
                                            </select>
                                            <mat-icon>expand_more</mat-icon>
                                        </div>
                                    </div>
                                </div>
                                <div class="error-text" *ngIf="isDaysInvalid(reminder)">
                                    Max 20 days allowed
                                </div>

                                <!-- At Time Row (Hidden for Minutes) -->
                                <div class="schedule-row" *ngIf="reminder.delayUnit !== 'Minutes'">
                                    <span class="row-label">At</span>
                                    <div class="time-inputs">
                                        <!-- Hour Select -->
                                        <div class="select-wrapper time-component">
                                            <select [(ngModel)]="reminder.tempHour"
                                                (ngModelChange)="updateTime(reminder)">
                                                <option *ngFor="let h of hours" [ngValue]="h">{{h}}</option>
                                            </select>
                                            <mat-icon>expand_more</mat-icon>
                                        </div>
                                        <!-- AM/PM Select -->
                                        <div class="select-wrapper time-component">
                                            <select [(ngModel)]="reminder.tempPeriod"
                                                (ngModelChange)="updateTime(reminder)">
                                                <option *ngFor="let p of periods" [value]="p">{{p}}</option>
                                            </select>
                                            <mat-icon>expand_more</mat-icon>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Channel Wrapper -->
                        <div class="channels-wrapper">
                            <!-- Channel Toggles -->
                            <div class="control-group">
                                <label>Active Channels</label>
                                <div class="channel-toggles">
                                    <div class="channel" [class.active]="reminder.channels.includes('WHATSAPP')"
                                        (click)="reminder.isEnabled && toggleChannel(reminder, 'WHATSAPP')">
                                        <div class="channel-content">
                                            <mat-icon>chat</mat-icon> <span>WhatsApp</span>
                                        </div>
                                        <mat-icon *ngIf="reminder.channels.includes('WHATSAPP')"
                                            class="check-icon">check_circle</mat-icon>
                                    </div>
                                    <div class="channel" [class.active]="reminder.channels.includes('EMAIL')"
                                        (click)="reminder.isEnabled && toggleChannel(reminder, 'EMAIL')">
                                        <div class="channel-content">
                                            <mat-icon>email</mat-icon> <span>Email</span>
                                        </div>
                                        <mat-icon *ngIf="reminder.channels.includes('EMAIL')"
                                            class="check-icon">check_circle</mat-icon>
                                    </div>
                                </div>
                            </div>

                            <!-- Template Configs (Conditional) -->
                            <div class="template-configs">
                                <!-- WhatsApp Template -->
                                <div class="config-block whatsapp" *ngIf="reminder.channels.includes('WHATSAPP')"
                                    [class.highlight]="previewTemplateId === reminder.whatsappTemplate && previewType === 'WHATSAPP' && previewReminderId === reminder.id">
                                    <label><mat-icon>chat</mat-icon> WhatsApp Template</label>
                                    <div class="select-row">
                                        <div class="select-wrapper">
                                            <select [(ngModel)]="reminder.whatsappTemplate"
                                                (ngModelChange)="markModified(reminder)"
                                                [disabled]="!reminder.isEnabled">
                                                <option *ngFor="let t of whatsappTemplates" [value]="t.id">{{t.name}}
                                                </option>
                                            </select>
                                            <mat-icon class="chevron">expand_more</mat-icon>
                                        </div>
                                        <button class="preview-btn"
                                            (click)="previewTemplate(reminder.whatsappTemplate, 'WHATSAPP', reminder.id)"
                                            [class.active]="previewTemplateId === reminder.whatsappTemplate && previewType === 'WHATSAPP' && previewReminderId === reminder.id"
                                            matTooltip="Preview WhatsApp">
                                            <mat-icon>visibility</mat-icon>
                                        </button>
                                    </div>
                                </div>

                                <!-- Email Template -->
                                <div class="config-block email" *ngIf="reminder.channels.includes('EMAIL')"
                                    [class.highlight]="previewTemplateId === reminder.emailTemplate && previewType === 'EMAIL' && previewReminderId === reminder.id">
                                    <label><mat-icon>email</mat-icon> Email Template</label>
                                    <div class="select-row">
                                        <div class="select-wrapper">
                                            <select [(ngModel)]="reminder.emailTemplate"
                                                (ngModelChange)="markModified(reminder)"
                                                [disabled]="!reminder.isEnabled">
                                                <option *ngFor="let t of emailTemplates" [value]="t.id">{{t.name}}
                                                </option>
                                            </select>
                                            <mat-icon class="chevron">expand_more</mat-icon>
                                        </div>
                                        <button class="preview-btn"
                                            (click)="previewTemplate(reminder.emailTemplate, 'EMAIL', reminder.id)"
                                            [class.active]="previewTemplateId === reminder.emailTemplate && previewType === 'EMAIL' && previewReminderId === reminder.id"
                                            matTooltip="Preview Email">
                                            <mat-icon>visibility</mat-icon>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Individual Save Button -->
                <div class="card-actions" *ngIf="reminder.isModified">
                    <div class="spacer"></div>
                    <button mat-flat-button class="save-btn" (click)="saveReminder(reminder)"
                        [disabled]="isDaysInvalid(reminder)">
                        Save Changes
                    </button>
                </div>
            </div>

            <button class="add-reminder-btn" (click)="addReminder()" [disabled]="reminders.length >= 10">
                <mat-icon>add_circle_outline</mat-icon>
                <span>Add Another Reminder ({{reminders.length}}/10)</span>
            </button>

        </div>

        <!-- Right Column: Visual Preview -->
        <div class="preview-column">
            <div class="sticky-wrapper" [style.marginTop.px]="previewOffset" style="transition: margin-top 0.3s ease;">
                <div class="preview-label" *ngIf="previewType === 'WHATSAPP'"><mat-icon>chat</mat-icon> WhatsApp Preview
                </div>
                <div class="preview-label" *ngIf="previewType === 'EMAIL'"><mat-icon>email</mat-icon> Email Preview
                </div>

                <div class="preview-heading" *ngIf="previewTemplateId">
                    <span class="template-name">{{getTemplateName(previewTemplateId)}}</span>
                </div>

                <!-- WhatsApp Preview Wrapper -->
                <ng-container *ngIf="previewType === 'WHATSAPP'">
                    <div class="preview-device whatsapp-mode">
                        <div class="device-notch"></div>
                        <div class="device-screen">
                            <div class="msg-bubble incoming">
                                <div class="avatar">E</div>
                                <div class="bubble-content">
                                    <div class="bubble-meta">Evaltrix • Just now</div>
                                    <div class="bubble-body">
                                        <div [innerHTML]="getPreviewContent()" *ngIf="getPreviewContent()"></div>
                                        <p *ngIf="!getPreviewContent()">Select a template to preview...</p>
                                        <div class="timestamp-row">
                                            <span class="time">10:09 PM</span>
                                            <mat-icon class="ticks">done_all</mat-icon>
                                        </div>
                                    </div>
                                    <div class="bubble-actions">
                                        <div class="action-btn">
                                            <mat-icon>open_in_new</mat-icon>
                                            <span>View Assessment</span>
                                        </div>
                                        <div class="action-btn" *ngIf="showNotInterested(previewTemplateId)">
                                            <mat-icon>open_in_new</mat-icon>
                                            <span>Not Interested</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="device-chin"></div>
                    </div>
                </ng-container>

                <!-- Email Preview Wrapper -->
                <ng-container *ngIf="previewType === 'EMAIL'">
                    <div class="preview-window email-mode">
                        <div class="window-header">
                            <div class="dots">
                                <span></span><span></span><span></span>
                            </div>
                            <div class="address-bar"><span class="subject-label">Subject:</span>{{getPreviewSubject()}}
                            </div>
                        </div>
                        <div class="window-body">
                            <div class="email-header">
                                <div class="avatar">E</div>
                                <div class="meta">
                                    <strong>Evaltrix Team</strong>
                                    <span>to me</span>
                                </div>
                            </div>
                            <div class="email-content">
                                <div [innerHTML]="getPreviewContent()" *ngIf="getPreviewContent()"></div>
                                <p *ngIf="!getPreviewContent()">Select a template to preview...</p>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>